module.exports = __webpack_public_path__ + "img/reserved_6.b2d2c9b2.jpg";